// eslint-disable-next-line import/prefer-default-export
import loadable from '@loadable/component'

export const RatingKey = loadable(() => import('./RatingKey'))
export type { RatingKeyProps } from './RatingKey'
